
import { Component, Vue, Model, Prop } from 'vue-property-decorator';

@Component
export default class SliderSection extends Vue {
  @Prop() readonly icon!: string;
  @Prop() readonly iconColor!: string;
  @Prop() readonly heading!: string;
  @Prop() readonly trackLabels!: [string, string, string];
  @Model('change', { type: Number }) sliderValue!: number;

  get sliderPosition() {
    return this.sliderValue;
  }

  set sliderPosition(newVal: number) {
    this.$emit('change', newVal);
  }
}
